import { defineNuxtPlugin } from '#imports';
import * as Sentry from '@sentry/vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  httpContextIntegration,
  dedupeIntegration,
  linkedErrorsIntegration,
  breadcrumbsIntegration,
  browserApiErrorsIntegration,
  eventFiltersIntegration,
  functionToStringIntegration,
  globalHandlersIntegration,
} from '@sentry/browser';

export default defineNuxtPlugin(async (nuxtApp) => {
  const config = nuxtApp.$config;
  Sentry.init({
    app: nuxtApp.vueApp,
    enabled: config.public.sentry.enabled,
    dsn: config.public.sentry.fakeDsn,
    tunnel: '/api/sentry',
    environment: config.public.mode.name,
    integrations: [],

    // overwrite default integrations to disable "browserSessionIntegration"
    defaultIntegrations: [
      eventFiltersIntegration(),
      functionToStringIntegration(),
      browserApiErrorsIntegration(),
      breadcrumbsIntegration(),
      globalHandlersIntegration(),
      linkedErrorsIntegration(),
      dedupeIntegration(),
      httpContextIntegration(),
    ],

    tracePropagationTargets: ['localhost', config.public.baseUrl],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
    profilesSampleRate: 0,
    sendClientReports: false,
    debug: false,
  });

  globalThis.$sentry = {
    // @ts-ignore
    captureException: Sentry.captureException,
    // @ts-ignore
    captureMessage: Sentry.captureMessage,
  };
  nuxtApp.provide('sentry', globalThis.$sentry);
});
